import moment from 'jalali-moment'

export const getOneMonthLater = () => {
    const date = new Date()
    date.setMonth(date.getMonth() + 1)
    date.setHours(0, 0, 0, 0)
    const result = moment
        .from(date.toLocaleDateString(), 'YYYY-MM-DD')
        .locale('en')
        .format('YYYY-MM-DD')
    return result
}
